<template>
  <div class="mynews">
    <!-- <top-nav ref="TopNav"></top-nav>
    <van-nav-bar title="我的消息" fixed left-arrow @click-left="goBack" @click-right="onClickRight">
      <van-icon slot="right" class="iconfont icon-zhankai"></van-icon>
    </van-nav-bar> -->
    <GlobTopNav title="我的消息" :rightHidden="false"> </GlobTopNav>

    <div class="van-content">
      <van-tabs @click="vantabPlay">
        <van-tab title="文章"></van-tab>
        <van-tab title="通知"></van-tab>
      </van-tabs>

      <div class="nodata text-cent" v-if="finished && datalist == ''">
        <img src="./../../../assets/img/msg-bull.png" />
        <span class="text">还没有相关消息~</span>
      </div>
      <div class="newslist">
        <van-list v-model="loading" :finished="finished" :offset="-1">
          <div
            class="list-item"
            v-for="(items, index) in datalist"
            :key="items.id"
            @click="setWZ(items)"
          >
            <div class="tiems">
              {{ items.add_time }}
            </div>

            <div class="list-item-cont">
              <div class="title ellipseal">
                {{ items.title }}
              </div>
              <div class="conter">
                <div v-html="items.content" class="info ellipseal"></div>
              </div>
            </div>
          </div>
          <div v-if="!loading && finished && datas != ''" class="nomore">没有更多了~</div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/topnav'
export default {
  name: 'mynews',
  components: {
    TopNav
  },
  data() {
    return {
      datas: [],
      datalist: '',
      page: 0,
      active: this.$route.query.type,
      finished: false,
      loading: true
    }
  },
  methods: {
    goBack: function () {
      this.$router.push({ name: 'User' })
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay()
    },
    // 获取通知列表
    getnotice: function () {
      var isUser = localStorage.getItem('BLHuser')
      var mallid = localStorage.getItem('mallid')
      this.$api.post(
        '/notice/list',
        {
          p: this.page,
          token_user: isUser,
          id_example: mallid
        },
        res => {
          this.datalist = res.data.data
          this.finished = true
          this.loading = false
        }
      )
    },
    // 获取文章列表
    getarticle: function () {
      var isUser = localStorage.getItem('BLHuser')
      var mallid = localStorage.getItem('mallid')
      this.$api.post(
        '/article/list',
        {
          p: this.page,
          token_user: isUser,
          id_example: mallid
        },
        res => {
          this.datalist = res.data.data
          this.finished = true
          this.loading = false
        }
      )
    },
    vantabPlay: function (index) {
      if (index == 0) {
        this.getarticle()
      } else {
        this.getnotice()
      }
    },
    setWZ(item) {
      if (item.article_id) {
        this.$router.push({ name: 'News', query: { article_id: item.article_id } })
      } else if (item.notice_id) {
        this.$router.push({ name: 'News', query: { notice_id: item.notice_id } })
      }
    }
  },
  mounted() {
    this.getarticle()
  }
}
</script>

<style lang="less">
.mynews {
  background-color: rgba(245, 245, 245, 1);
  min-height: 100vh;
  padding-bottom: 1rem;

  .van-content {
    padding-bottom: 0;
  }
  .newslist {
    box-sizing: border-box;
    padding: 0 0.2rem;

    .list-item {
      overflow: hidden;
      margin-top: 0.32rem;
      margin-bottom: 0;

      .tiems {
        font-size: 0.24rem;
        font-weight: 400;
        color: #929292;
        line-height: 0.42rem;
        margin-bottom: 0.1rem;
      }

      .list-item-cont {
        width: 100%;
        background-color: #fff;
        border-radius: 0.2rem;
        box-sizing: border-box;
        padding: 0.3rem 0.4rem;
        overflow: hidden;

        .title {
          color: #262626;
          font-size: 0.28rem;
          padding-bottom: 0.1rem;
          border-bottom: 0.02rem solid #f5f5f5;
        }

        .conter {
          box-sizing: border-box;
          padding: 0.2rem 0 0.1rem 0;
        }
      }
    }
    .newsbox {
      width: 100%;
      background-color: #fff;
      border-radius: 0.1rem;
      padding: 0.1rem 0.15rem;
      .van-icon-arrow {
        position: absolute;
        right: 0.35rem;
        top: 50%;
        margin-top: -0.1rem;
      }
      .van-card {
        background-color: initial;
        padding: 0 0.35rem 0 0.7rem;
        height: 0.65rem;
        margin-top: 0;
        .newsimgbox {
          left: 0;
          width: 0.6rem;
          height: 0.6rem;
        }
        .news-content {
          height: 0.6rem;
        }
      }
      .noimg {
        padding-left: 0;
      }
    }
  }
  table {
    border-top: 0.01rem solid #ccc;
    border-left: 0.01rem solid #ccc;
    th {
      border-bottom: 0.01rem solid #ccc;
      border-right: 0.01rem solid #ccc;
      text-align: center;
    }
    td {
      border-bottom: 0.01rem solid #ccc;
      border-right: 0.01rem solid #ccc;
      padding: 0.03rem 0.05rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/mynews/mynews.vue